import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import ArrowSubtitle from "../ArrowSubtitle/ArrowSubtitle";
import styles from "./SectionHeading.module.css";

function SectionHeading({
    heading,
    children,
    textStyle,
    headingStyle,
    arrowText,
    darkArrowSubtitle,
    mainStyle,
}) {
    const [ref, , fadeClassName] = useIntersectionObserver(0.2);
    return (
        <div className={styles.section_heading} style={mainStyle} ref={ref}>
            {arrowText && (
                <ArrowSubtitle
                    text={arrowText}
                    dark={darkArrowSubtitle}
                    className={fadeClassName}
                />
            )}
            <h2
                className={[styles.heading, fadeClassName].join(" ")}
                style={headingStyle}
            >
                {heading}
            </h2>
            {children && (
                <p
                    className={[styles.description, fadeClassName].join(" ")}
                    style={textStyle}
                >
                    {children}
                </p>
            )}
        </div>
    );
}

export default SectionHeading;
